import React from "react";
import PropTypes from "prop-types";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";

import "../styles/components/ImagesList.scss";

const ImagesList = ({ images }) => {
    if (images.length === 0) {
        return null;
    }

    return (
        <div className="images-list">
            {images.map(({ link, image }) =>
                link ? (
                    <a
                        key={link || image.file.url}
                        aria-label={link}
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        className="cursor-pointer"
                    >
                        <GatsbyImageWithSVGSupport image={image} />
                    </a>
                ) : (
                    <GatsbyImageWithSVGSupport
                        key={link || image.file.url}
                        image={image}
                    />
                )
            )}
        </div>
    );
};

ImagesList.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            gatsbyImageData: PropTypes.object,
            file: PropTypes.shape({
                url: PropTypes.string.isRequired,
            }),
            alt: PropTypes.string,
            url: PropTypes.string,
        })
    ).isRequired,
    className: PropTypes.string,
};

export default ImagesList;
